import ApiClient from './ApiClient'
import OpenApiClient from './OpenApiClient'
import S3ApiClient from './S3ApiClient'

const client = new S3ApiClient()
const openClient = new OpenApiClient()
const adminClient = new ApiClient()

export default {
  /**
   * コメント一覧を取得
   */
  getComments (id) {
    return client.get(`data/comments/${id}.json?t=${new Date().getTime()}`)
  },
  /**
   * 一般：コメントを投稿
   */
  postComment (body = null) {
    return openClient.post('op/comments', body)
  },
  /**
   * 一般：投稿内容プレビュー用画面
   */
  postCommentConfirm (body = null) {
    return openClient.post('op/comments/confirm', body)
  },
  /**
   * 受賞者モード：コメントを投稿
   */
  adminPostComment (body = null) {
    return adminClient.post('me/comments', body)
  },
  /**
   * 受賞者モード：投稿内容プレビュー用画面
   */
  adminPostCommentConfirm (body = null) {
    return adminClient.post('me/comments/confirm', body)
  }
}
